
(function () {



  const ANTI_THEFT_VARIANT_ID = 45654878814394;
  const pending = new Map();

  const genReqId = () => {
    if (window.crypto?.randomUUID) return crypto.randomUUID();
    return String(Date.now()) + "_" + Math.random().toString(16).slice(2);
  };

  window.addEventListener("cst:cart:updated", (e) => {
    const reqId = e?.detail?.requestId;
    if (!reqId) return;

    const btn = pending.get(reqId);
    if (!btn) return;

    pending.delete(reqId);
    setBusy(btn, false); 
  });









  const SELECTOR = '[data-atc="true"]';

  const safeJson = (s) => {
    try { return JSON.parse(s); } catch { return null; }
  };

  const getVariantIdFromButtonOrScope = (btn) => {
    // 1) data-variant-id
    const direct = btn?.dataset?.variantId;
    if (direct) return Number(direct);

    // 2) buton bir form içindeyse input[name=id] (Shopify product form pattern)
    const form = btn.closest("form");
    const idInput = form?.querySelector('input[name="id"]');
    if (idInput?.value) return Number(idInput.value);

    return 0;
  };

  const getPropertiesFromButton = (btn) => {
    // data-properties JSON string olarak beklenir
    const raw = btn?.dataset?.properties;
    if (!raw) return null;
    const obj = safeJson(raw);
    return obj && typeof obj === "object" ? obj : null;
  };

  const setBusy = (btn, busy) => {
    if (!btn) return;
    btn.disabled = !!busy;
    btn.dataset.atcBusy = busy ? "1" : "0";
    btn.classList.toggle("is-loading", !!busy);
  };

const addToCart = async ({ btn, id, quantity = 1, properties = null, open = true, requestId = null }) => {
  if (!id) throw new Error("Missing variant id");

  const isBundleAntiTheft = btn?.dataset?.atcBundle === "anti-theft";

  if (isBundleAntiTheft) {
    if (window.CSTDrawer?.add) {
      await window.CSTDrawer.add({ id, quantity, properties, open: false, requestId: null });

      await window.CSTDrawer.add({ id: ANTI_THEFT_VARIANT_ID, quantity: 1, properties: null, open: false, requestId: null });

      await window.CSTDrawer.refresh?.();
      window.CSTDrawer.open?.();

      window.dispatchEvent(new CustomEvent("cst:cart:updated", { detail: { source: "bundle", requestId } }));
      return;
    }

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          { id, quantity, properties: properties || undefined },
          { id: ANTI_THEFT_VARIANT_ID, quantity: 1 },
        ],
      }),
    });

    if (!res.ok) {
      let msg = "Add bundle failed";
      try {
        const j = await res.json();
        msg = j?.description || j?.message || msg;
      } catch {
        msg = await res.text();
      }
      throw new Error(msg);
    }

    window.dispatchEvent(new CustomEvent("cst:cart:open"));
    window.dispatchEvent(new CustomEvent("cst:cart:refresh"));

    window.dispatchEvent(new CustomEvent("cst:cart:updated", { detail: { source: "bundle", requestId } }));
    return;
  }

  if (window.CSTDrawer?.add) {
    await window.CSTDrawer.add({ id, quantity, properties, open, requestId });
    return;
  }

  window.dispatchEvent(
    new CustomEvent("cst:cart:add", {
      detail: { id, quantity, properties, open, requestId },
    })
  );
};

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(SELECTOR);
    if (!btn) return;

    if (btn.dataset.atcBusy === "1") return;

    const id = getVariantIdFromButtonOrScope(btn);
    const properties = getPropertiesFromButton(btn);

    const wrap = btn.closest("[data-atc-scope]") || btn.parentElement;
    const errorEl = wrap?.querySelector?.("[data-atc-error]") || wrap?.querySelector?.("#atc-error");

    if (!id) {
      if (errorEl) errorEl.hidden = false;
      return;
    } else {
      if (errorEl) errorEl.hidden = true;
    }

    setBusy(btn, true);

    const requestId = genReqId();
    pending.set(requestId, btn);

    try {
      await addToCart({ btn, id, quantity: 1, properties, open: true, requestId });
    } catch (err) {
      console.error("[global-atc] add failed:", err);
      alert(err?.message || "Could not add to cart.");
      pending.delete(requestId);
      setBusy(btn, false);
    } 
  });
})();




(function () {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-cst-cart-trigger]");
    if (!btn) return;

    // Drawer aç + güncelle
    if (window.CSTDrawer?.open) {
      window.CSTDrawer.open();
      window.CSTDrawer.refresh?.();
      return;
    }

    // fallback
    window.dispatchEvent(new CustomEvent("cst:cart:open"));
  });
})();